import windowReducer, { moduleName as windowModule } from 'models/window'
import menuReducer, { moduleName as menuModule } from 'models/menu'

const combinerReducer = {
    [windowModule]: windowReducer,
    [menuModule]: menuReducer,
}

export default combinerReducer
